<template>
  <button
    type="button"
    class="deeplink-pick"
    :class="{ disabled }"
    :disabled="disabled"
    :aria-label="'deeplink-pick'"
    :title="t('popup.link.chooseOnMap')"
    @click="open"
  >
    <i class="fas fa-map-marked-alt"></i>
  </button>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useEditorLink } from '../composables/useEditorLink';

withDefaults(defineProps<{ disabled?: boolean }>(), { disabled: false });
const emit = defineEmits<{ picked: [href: string] }>();

const { t } = useI18n();
// The overlay is rendered once by MapPickerHost, not here: a second instance
// would stack on top of whichever popup the field itself lives in.
const { openMapPicker } = useEditorLink();

function open(): void {
  openMapPicker((href: string) => emit('picked', href));
}
</script>

<style lang="scss">
.deeplink-pick {
  flex: none;
  padding: 4px 8px;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  cursor: pointer;

  &.disabled {
    opacity: 0.4;
    cursor: default;
  }
}
</style>
